import { TemplateRef } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { CUSTOMER_TYPES } from '../../../services/constant';
import { FormBuilder, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '../../../services/alert.service';
var CustomerDetailComponent = (function () {
    function CustomerDetailComponent(alertService, apiService, formBuilder, modalService, translateService) {
        this.alertService = alertService;
        this.apiService = apiService;
        this.formBuilder = formBuilder;
        this.modalService = modalService;
        this.translateService = translateService;
        this.parent = null;
        this.customerTypes = CUSTOMER_TYPES.map(function (obj) { return ({ label: obj.name, value: obj.value }); });
        this.isCreate = true;
        this.refreshDropdown = false;
        this.isThailand = true;
        this.isCountry = 'TH';
    }
    CustomerDetailComponent.prototype.open = function (parent, buyerType, buyer) {
        var _this = this;
        this.parent = parent;
        this.isCreate = !buyer;
        this.createBuyerForm(buyer);
        this.createValidateCountry();
        this.buyerForm.get('country').valueChanges.subscribe(function () {
            _this.adjustCountryValidate();
        });
        this.modal = this.modalService.open(this.modalTemplate, { size: 'lg', centered: true });
    };
    CustomerDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadCountry();
        this.translateService.onLangChange.subscribe(function () {
            _this.translateDropdown();
        });
    };
    Object.defineProperty(CustomerDetailComponent.prototype, "currentLang", {
        get: function () {
            return this.translateService.currentLang;
        },
        enumerable: true,
        configurable: true
    });
    CustomerDetailComponent.prototype.translateDropdown = function () {
        var _this = this;
        this.refreshDropdown = true;
        setTimeout(function () {
            _this.refreshDropdown = false;
        }, 1);
    };
    CustomerDetailComponent.prototype.createBuyerForm = function (buyer) {
        this.buyerForm = this.formBuilder.group({
            id: [buyer ? buyer.id : null],
            name: [buyer ? buyer.name : null, Validators.required],
            taxID: [buyer ? buyer.tax_id : null, [this.validateTaxID, Validators.required]],
            branchCode: [buyer ? buyer.branch_code : null, [this.validateBranchCode, Validators.required]],
            branchName: [buyer ? buyer.branch_name : null, Validators.required],
            address: [buyer ? buyer.address : null, Validators.required],
            postCode: [buyer ? buyer.post_code : null, Validators.required],
            country: [buyer ? buyer.country_code : 'TH', Validators.required],
            phoneNumber: [buyer ? buyer.phone_number : null],
            email: [buyer ? buyer.email : null, this.validateEmail],
            ccEmail: [buyer ? buyer.cc_email : null, this.validateCCEmail],
        });
        if (buyer && buyer.branch_name === 'HQ') {
            this.isHeadOffice = true;
        }
    };
    CustomerDetailComponent.prototype.setBuyerHeadOffice = function () {
        if (this.isHeadOffice) {
            this.branchName.setValue('HQ');
            this.branchCode.setValue('00000');
            this.branchCode.disable();
        }
        else {
            this.branchName.setValue('');
            this.branchCode.setValue('');
            this.branchCode.enable();
        }
    };
    CustomerDetailComponent.prototype.setHeadOfficeCheckbox = function (event) {
        this.isHeadOffice = event.target.value === 'HQ';
    };
    CustomerDetailComponent.prototype.createValidateCountry = function () {
        this.buyerForm.controls['postCode'].setValidators([this.validatePostCode]);
        this.buyerForm.controls['taxID'].setValidators([this.validateTaxID, Validators.required]);
        this.buyerForm.controls['postCode'].updateValueAndValidity();
        this.buyerForm.controls['taxID'].updateValueAndValidity();
    };
    CustomerDetailComponent.prototype.adjustCountryValidate = function () {
        if (this.buyerForm.get('country').value === 'TH') {
            this.isThailand = true;
            this.buyerForm.controls['postCode'].setValidators([this.validatePostCode]);
            this.buyerForm.controls['taxID'].setValidators([this.validateTaxID]);
        }
        else {
            this.isThailand = false;
            this.buyerForm.controls['postCode'].setValidators([]);
            this.buyerForm.controls['taxID'].setValidators([this.validateTaxIDOtherCountry]);
        }
        this.buyerForm.controls['postCode'].updateValueAndValidity();
        this.buyerForm.controls['taxID'].updateValueAndValidity();
    };
    CustomerDetailComponent.prototype.validateTaxID = function (control) {
        if (control.value && (control.value.length !== 13 && control.value.length !== 18 && control.value.toLowerCase() !== 'n/a')) {
            return { 'taxIDInvalid': true };
        }
        return null;
    };
    CustomerDetailComponent.prototype.validateTaxIDOtherCountry = function (control) {
        if (control.value && (control.value.length > 20 && control.value.toLowerCase() !== 'n/a')) {
            return { 'taxIDInvalid': true };
        }
        return null;
    };
    CustomerDetailComponent.prototype.validatePostCode = function (control) {
        if (control.value && Boolean(control.value.match(/^[0-9]{5}$/g))) {
            return null;
        }
        return { postalCodeInvalid: true };
    };
    CustomerDetailComponent.prototype.validateBranchCode = function (control) {
        if (control.value) {
            if (!Boolean(control.value.match(/^[0-9]{5}$/g))) {
                return { branchCodeInvalid: true };
            }
        }
        return null;
    };
    CustomerDetailComponent.prototype.validateEmail = function (control) {
        if (control.value) {
            return Validators.email(control);
        }
        return null;
    };
    CustomerDetailComponent.prototype.validateCCEmail = function (control) {
        if (control.value) {
            var emails = control.value.split(',');
            var re_1 = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
            emails.forEach(function (email) {
                if (!re_1.test(email.trim())) {
                    return { 'ccEmailInvalid': re_1.test(email.trim()) };
                }
            });
            return null;
        }
        return null;
    };
    CustomerDetailComponent.prototype.loadCountry = function () {
        var _this = this;
        this.apiService.getCountry().subscribe(function (res) {
            _this.countryList = res || [];
        }, function (err) {
            _this.alertService.toastNotify({
                type: 'error',
                text: err.statusText,
                timer: 3000,
            });
        });
    };
    CustomerDetailComponent.prototype.submit = function () {
        var _this = this;
        if (this.buyerForm.invalid) {
            return;
        }
        var data = {
            name: this.name.value,
            tax_id: this.taxID.value,
            address: this.address.value,
            branch_code: this.branchCode.value,
            branch_name: this.branchName.value,
            post_code: this.postCode.value,
            country_code: this.country.value,
            email: this.email.value,
            cc_email: this.ccEmail.value
        };
        // get API by operation
        var api = null;
        if (this.isCreate) {
            api = this.apiService.createBuyerBranch(data);
        }
        else {
            api = this.apiService.updateBuyerBranch(this.id.value, data);
        }
        api.subscribe(function () {
            _this.modal.close();
            _this.sniff('UPDATE_CUSTOMER', data.name);
            _this.parent.reloadDropdown();
            _this.alertService.toastNotify({
                type: 'success',
                text: _this.translateService.instant('SETTINGS.SAVED-SUCCESSFULLY'),
                timer: 2000,
            });
        }, function (err) {
            var errorMessage = err.error.detail || err.statusText;
            _this.alertService.toastNotify({
                type: 'error',
                text: errorMessage,
                timer: 3000,
            });
        });
    };
    CustomerDetailComponent.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: 'CUS_INFO',
            target: target
        };
        this.apiService.sniff(data).subscribe(function (res) {
        });
    };
    Object.defineProperty(CustomerDetailComponent.prototype, "id", {
        get: function () {
            return this.buyerForm.get('id');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerDetailComponent.prototype, "name", {
        get: function () {
            return this.buyerForm.get('name');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerDetailComponent.prototype, "taxID", {
        get: function () {
            return this.buyerForm.get('taxID');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerDetailComponent.prototype, "branchCode", {
        get: function () {
            return this.buyerForm.get('branchCode');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerDetailComponent.prototype, "branchName", {
        get: function () {
            return this.buyerForm.get('branchName');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerDetailComponent.prototype, "address", {
        get: function () {
            return this.buyerForm.get('address');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerDetailComponent.prototype, "postCode", {
        get: function () {
            return this.buyerForm.get('postCode');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerDetailComponent.prototype, "country", {
        get: function () {
            return this.buyerForm.get('country');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerDetailComponent.prototype, "phoneNumber", {
        get: function () {
            return this.buyerForm.get('phoneNumber');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerDetailComponent.prototype, "buyerType", {
        get: function () {
            return this.buyerForm.get('buyerType');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerDetailComponent.prototype, "email", {
        get: function () {
            return this.buyerForm.get('email');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerDetailComponent.prototype, "ccEmail", {
        get: function () {
            return this.buyerForm.get('ccEmail');
        },
        enumerable: true,
        configurable: true
    });
    CustomerDetailComponent.prototype.numberOnly = function (event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    };
    return CustomerDetailComponent;
}());
export { CustomerDetailComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/customer/customer-detail/customer-detail.component.ts.pre-build-optimizer.js